import React, { useState, useEffect, memo } from 'react';
import Map from '../Map';
import ProductTile from '../Product/ProductTile';
import { getProductPrices } from '@/actions/ecom/productDetail';
import useTriggerRequest from '@/hooks/useTriggerRequest';

const ProductTiles = ({ products }: any) => {
  const fetch = (...args: any) => getProductPrices.apply(null, args);
  const { data: fetchedPricesData, trigger } = useTriggerRequest({ fetch });
  useEffect(() => {
    const productIds: string[] = [];
    products.data.forEach((item: any) => {
      productIds.push(item?.attributes?.productId);
    });
    trigger(productIds);
  }, [products?.data]);

  return (
    <Map
      className="grid grid-cols-2 md:grid-cols-4 gap-s5"
      list={products.data}
      data-testid="product-list-wrapper"
      render={(product, index) => (
        <ProductTile
          key={product.id}
          price={fetchedPricesData?.data?.prices[index]?.amount}
          {...product}
        />
      )}
    />
  );
};
export default memo(ProductTiles);
